import batchCreateComponent from './batch.create.component';

let batchCreateModule = angular.module('batchcreate', [
  ])

  .component('batchcreate', batchCreateComponent)

  .name;

export default batchCreateModule;


// WEBPACK FOOTER //
// ./client/app/components/batch/create/index.js